import { render, staticRenderFns } from "./ProductSpecialDetail.vue?vue&type=template&id=0ada8228&scoped=true"
import script from "./ProductSpecialDetail.vue?vue&type=script&lang=js"
export * from "./ProductSpecialDetail.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecialDetail.vue?vue&type=style&index=0&id=0ada8228&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada8228",
  null
  
)

export default component.exports